import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {LocalCustomerSettingsModel} from '../../../../models/LocalCustomerSettingsModel';
import {LocalCustomerModel} from '../../../../models/LocalCustomerModel';
import {RegionModel} from '../../../../models/RegionModel';
import {Subscription} from 'rxjs';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {LocalCustomerSettingService} from '../service/local-customer.service';
import * as toastr from 'toastr';
import {LoaderService} from '../../../general-services/service-loader/loader.service';

@Component({
  selector: 'app-edit-local-customer',
  templateUrl: './edit-local-customer.component.html',
  styleUrls: ['./edit-local-customer.component.scss']
})
export class EditLocalCustomerComponent extends ProjectConstants implements OnInit, OnDestroy {

  showActions: boolean;
  showLC: boolean;
  showRegion: boolean;

  localCustomerSetting: LocalCustomerSettingsModel;
  localCustomerSelect: LocalCustomerModel;
  regionSelect: RegionModel;
  saveLocalCustomer: Subscription;
  parameterSubscribe: Subscription;

  registerForm: FormGroup;
  submitted = false;
  localCustomerJson: any;

  constructor(private route: ActivatedRoute, private router: Router,
              private localCustomerSettingService: LocalCustomerSettingService,
              private formBuilder: FormBuilder,
              private loaderService: LoaderService) {
    super();

    this.showActions = false;
    this.showLC  = false;
    this.showRegion  = false;
    this.localCustomerSetting = new LocalCustomerSettingsModel();
    this.localCustomerSelect = new LocalCustomerModel();
    this.regionSelect = new RegionModel();
  }

  ngOnInit() {
    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
            this.localCustomerJson = params['row'];
      });

    this.localCustomerSetting = JSON.parse(this.localCustomerJson) as LocalCustomerSettingsModel;
    this.localCustomerSelect = this.localCustomerSetting.localCustomer;
    this.regionSelect = this.localCustomerSetting.region;

    this.registerForm = this.formBuilder.group({
      localCustomerCod: [{value: '', disabled: false}, Validators.required],
      region: [{value: '', disabled: false}, Validators.required]
    });
    this.registerForm.patchValue({
      localCustomerCod: this.localCustomerSelect.cod
    });

    this.registerForm.patchValue({
      region: this.regionSelect.cod
    });
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.SETTINGS], {queryParams: {selectedIndex: 0}});
  }

  save() {
    this.submitted = true;
    if (this.registerForm.valid) {
      event.preventDefault();
      this.saveLocalCustomer = this.localCustomerSettingService.update(this.localCustomerSettingService.baseUrl, this.localCustomerSetting)
        .subscribe(
          (result: any) => {
            if (result === -1) {
              toastr.options.timeout = 5000;
              toastr.warning('Duplicate item, Local Customer already exists', 'Warning');
            } else if (result === -2) {
              toastr.options.timeout = 5000;
              toastr.warning('Element already used', 'Warning');
            } else {
              toastr.success('Local customer Setting was created with success', 'Success');
              this.router.navigate([this.LINKS.SETTINGS], {queryParams: {selectedIndex: 0}});
            }
          },
          error => {
            this.loaderService.display(false);
            toastr.error('Local Customer Setting was not created', 'Error');
          });
    }
  }

  ngOnDestroy(): void {
    if (this.saveLocalCustomer) {
      this.saveLocalCustomer.unsubscribe();
    }
    if (this.parameterSubscribe) {
      this.parameterSubscribe.unsubscribe();
    }
  }

  getElementSelectedLC($event) {
    this.localCustomerSetting.localCustomer = $event.row;
    this.localCustomerSelect = $event.row;
    this.registerForm.patchValue({
      localCustomerCod: this.localCustomerSelect.cod
    });
  }

  getElementSelectedRegion($event) {
    this.localCustomerSetting.region = $event.row;
    this.regionSelect = $event.row;
    this.registerForm.patchValue({
      region: this.regionSelect.cod
    });
  }

  toggleLC() {
    this.showLC = !this.showLC;
  }

  toggleRegion() {
    this.showRegion = !this.showRegion;
  }

  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }

  resetLc() {
    this.registerForm.patchValue({
      localCustomerCod: ''
    });
    this.localCustomerSelect = new LocalCustomerModel();
  }

  resetRegion() {
    this.registerForm.patchValue({
      region: ''
    });
    this.regionSelect = new RegionModel();
  }

  reset(){
    this.resetRegion();
    this.resetLc();
  }

  isValidInput(value: AbstractControl) {
    if (value.value !== null) {
      if (value.value !== '' && value.valid) {
        return 'is-valid';
      } else {
        return 'is-invalid';
      }
    } else {
      return 'is-invalid';
    }
  }
}

